import Vue from 'vue';
import msal from '@piri/vue-msal';

Vue.use(msal, {
  auth: {
    clientId: process.env.VUE_APP_AUTHENTICATION_CLIENT_ID,
    requireAuthOnInitialize: true,
    redirectUri: process.env.VUE_APP_AUTHENTICATION_REDIRECT_URI,
    autoRefreshToken: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
});
